/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "question-758ac583--sprite",
  "use": "question-758ac583--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"question-758ac583--sprite\">\r\n  <defs>\r\n    <clipPath id=\"question-758ac583--sprite_clip-Modal_Request_Email\">\r\n      <rect width=\"36\" height=\"36\" />\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"question-758ac583--sprite_Modal_Request_Email\" clip-path=\"url(#question-758ac583--sprite_clip-Modal_Request_Email)\">\r\n    <rect id=\"question-758ac583--sprite_Rectangle_10692\" data-name=\"Rectangle 10692\" width=\"36\" height=\"36\" fill=\"none\" />\r\n    <g id=\"question-758ac583--sprite_Group_13084\" data-name=\"Group 13084\" transform=\"translate(-1452.25 -1418.727)\">\r\n      <path id=\"question-758ac583--sprite_Path_7907\" data-name=\"Path 7907\" d=\"M1470.034,1442.383a1.5,1.5,0,0,1-1.5-1.5v-.84a4.761,4.761,0,0,1,2.512-4.185l1.727-.928a2.1,2.1,0,0,0,1.132-2.282c-.009-.036-.035-.121-.066-.2a2.184,2.184,0,0,0-1.16-1.236l-.126-.056a4.838,4.838,0,0,0-3.524-.174,2.953,2.953,0,0,0-1.864,1.831,1.5,1.5,0,0,1-2.83-1,5.931,5.931,0,0,1,3.746-3.681,7.849,7.849,0,0,1,5.7.282l.125.057a5.218,5.218,0,0,1,2.741,2.918,4.952,4.952,0,0,1,.19.617,5.11,5.11,0,0,1-2.677,5.585l-1.7.91a1.766,1.766,0,0,0-.93,1.548v.834A1.5,1.5,0,0,1,1470.034,1442.383Z\" fill=\"currentColor\" />\r\n      <g id=\"question-758ac583--sprite_Group_19976\" data-name=\"Group 19976\">\r\n        <circle id=\"question-758ac583--sprite_Ellipse_817\" data-name=\"Ellipse 817\" cx=\"1.5\" cy=\"1.5\" r=\"1.5\" transform=\"translate(1468.54 1443.724)\" fill=\"currentColor\" />\r\n      </g>\r\n    </g>\r\n    <rect id=\"question-758ac583--sprite_Rectangle_10695\" data-name=\"Rectangle 10695\" width=\"36\" height=\"36\" fill=\"none\" />\r\n  </g>\r\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
